<template lang="html">
  <div class="service-request">
    <div class="card-image">
      <div class="hero is-small has-text-centered">
        <div class="hero-body" :style="safeAreaInsetStyle">
          <h1 class="title capitalized">{{ serviceName }}</h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <slot class="default-slot"> </slot>
      <div class="cells">
        <!-- preferred by -->
        <cw-service-data-cell
          :description="preferredBy.description"
          :inputValue="preferredBy.inputValue"
          :stepNumber="preferredBy.stepNumber"
          :editing.sync="preferredBy.editing"
          expandedHeight="5em"
        >
          <div slot="input-control">
            <date-picker
              class="is-underlined date-picker"
              :config="datePickerConfig"
              placeholder="Choose a Date"
              v-model="preferredBy.inputValue"
            >
            </date-picker>
            <!-- <p class="help is-primary" v-if="inputDateIsToday">Please contact Dispatch to ensure this order can be filled today.</p> -->
          </div>
        </cw-service-data-cell>

        <!-- special instructions -->
        <cw-service-data-cell
          :description="specialInstructions.description"
          :inputValue="specialInstructions.inputValue"
          :stepNumber="specialInstructions.stepNumber"
          :editing.sync="specialInstructions.editing"
          :class="{
            danger:
              $v.instructions &&
              $v.instructions.$dirty &&
              !$v.instructions.required,
          }"
        >
          <div slot="input-control">
            <input
              class="input is-underlined"
              type="text"
              placeholder="Add brief instructions"
              v-model="specialInstructions.inputValue"
            />
          </div>
        </cw-service-data-cell>
        <slot name="other-cells">
          <!-- vary based on type of service request -->
        </slot>
      </div>
      <div class="is-padded-large has-text-centered">
        <a
          class="button is-black is-outlined is-rounded is-large"
          type="button"
          name="button"
          @click="$emit('submitted')"
        >
          <span>Submit</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import safeArea from '@/components/mixins/safe-area';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment/moment';

export default {
  name: 'cw-service-request',
  mixins: [validationMixin, safeArea],
  components: {
    'date-picker': flatPickr,
  },
  props: {
    serviceName: {
      type: String,
      required: false,
      default: '',
    },
    serviceIcon: {
      type: String,
      required: false,
      default: '',
    },
    requireSpecialInstructions: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      safeAreaDefaultInsetValue: '0px',
      specialInstructions: {
        description: 'Special Instructions',
        inputValue: '',
        stepNumber: 2,
        // this value is just a placeholder.
        // the $emit from the service-data-cell fully controls this cell's editing state.
        // this field exists for cells with more complex input types
        editing: false,
      },
      preferredBy: {
        description: 'Preferred By',
        inputValue: moment()
          .add(1, 'd')
          .format('MM-DD-YYYY'), // if you ever change this check down in inputDateIsToday()
        stepNumber: 1,
        editing: false,
      },
    };
  },
  validations() {
    let base = {};

    if (this.requireSpecialInstructions) {
      base.instructions = {
        required,
      };
    }
    return base;
  },
  computed: {
    date() {
      return this.preferredBy.inputValue;
    },
    instructions() {
      return this.specialInstructions.inputValue;
    },
    datePickerConfig() {
      // toDate because the picker expects a js date
      let minDate = moment()
        .startOf('date')
        .toDate();

      return {
        dateFormat: 'm-d-Y',
        // disableMobile : true,
        minDate,
      };
    },
    inputDateIsToday() {
      // this is used to restrict the timepicker only on today
      return this.date === moment().format('MM-DD-YYYY');
    },
  },
  watch: {},
  methods: {
    backToProjects() {
      this.$router.go(-1);
      this.$modal.hide('*');
    },
  },
};
</script>

<style lang="stylus" scoped>
.service-request .hero {
  background: #231F20

  .title {
    color: white;
  }
}
.cells {
}
.date-picker {
  font-size: 1.2rem;
}
</style>
